(function () {
    angular.module('PWAPoCApp').factory('mapService', mapService);

    mapService.$inject = [
        '$q',
        'esriLoader',
        'mapUtility'
    ];

    function mapService(
        $q,
        esriLoader,
        mapUtility
    ) {
        'use strict';

        var readyDeferred = null,
            mapCreatedDeferred = null;

        var mapService = {
            _factories: [],
            _services: [],
            _mapView: null,
            _targetElement: null,
            _is3D: false,
            _isUserInteraction: false,

            ctxMenu: null,

            mapCreated: function () {
                if (mapCreatedDeferred === null) {
                    mapCreatedDeferred = $q.defer();
                }

                return mapCreatedDeferred.promise;
            },

            ready: function () {
                if (readyDeferred === null) {
                    readyDeferred = $q.defer();
                }

                return readyDeferred.promise;
            }
        };

        esriLoader.require([
            'esri/Map',
            'esri/views/MapView',
            'dojo/on',
            'esri/geometry/Point',
            'esri/geometry/SpatialReference',
            'esri/geometry/Extent',
        ], function (
            Map,
            MapView,
            on,
            Point,
            SpatialReference
        ) {
            if (!readyDeferred) {
                readyDeferred = $q.defer();
            }

            var callbacks = {
                'mousemove': [],
                'click': [],
                'rightclick': [],
                'zoom': [],
                'center': [],
                'drag': [],
                'visibility-toggle': [],
                'mapview-create': []
            };

            var map = new Map();
            mapService.layers = [];
            mapService.layers3D = [];

            function executeCallbacks(eventName, evt, mapView, hitResponse) {
                if (callbacks[eventName]) {
                    for (var i = 0; i < callbacks[eventName].length; ++i) {
                        callbacks[eventName][i](evt, mapView, hitResponse);
                    }
                }
            }

            //Internal event handler functions
            function onMouseMove(evt) {
                var screenPoint = evt;

                //Dispatch only if not dragging
                if (evt.buttons === 0) {
                    var hitTestPromise = mapService._mapView.hitTest(screenPoint);

                    if (hitTestPromise) {
                        hitTestPromise.then(function (response) {
                            if (response.results && response.results.length > 0) {
                                executeCallbacks('mousemove', evt, mapService._mapView, response);
                            } else {
                                executeCallbacks('mousemove', evt, mapService._mapView);
                            }
                        });
                    }
                }
            }

            function onClick(evt) {
                if (evt.buttons === 0) {
                    var hitTestPromise = mapService._mapView.hitTest(evt);
                    if (hitTestPromise) {
                        hitTestPromise.then(function (response) {
                            if (response.results && response.results.length > 0) {
                                executeCallbacks('click', evt, mapService._mapView, response);
                            } else {
                                executeCallbacks('click', evt, mapService._mapView);
                            }
                        });
                    }
                }
            }

            function onZoom(evt) {
                executeCallbacks('zoom', evt);
            }

            function onCenter(evt) {
                executeCallbacks('center', evt);
            }

            function onDrag(evt) {
                executeCallbacks('drag', evt);
            }

            mapService.createMap = function (mapId) {
                if (mapCreatedDeferred === null) {
                    mapCreatedDeferred = $q.defer();
                }

                if (mapService._targetElement && mapService._mapView) {
                    $('#' + mapId).replaceWith(mapService._targetElement);
                    return;
                }

                mapService._targetElement = $('#' + mapId);

                var mapView = new MapView({
                    container: mapId,
                    map: map,
                    constraints: {
                        rotationEnabled: true
                    },
                    popup: {
                        autoOpenEnabled: false
                    },
                    zoom: 3
                });

                mapView.ui.components = ["zoom"];
                mapService._mapView = mapView;

                mapService._mapView.when(() => mapCreatedDeferred.resolve());

                //Set mapView for services
                for (var i = 0; i < mapService._services.length; ++i) {
                    mapService._services[i].ready().then(function (service) {
                        service.mapView = mapService._mapView;
                    });
                }

                on(mapService._mapView.container, 'mousemove', onMouseMove);
                on(mapService._mapView.container, 'click', onClick);
                mapService._mapView.watch('zoom', onZoom);
                mapService._mapView.watch('center', onCenter);
                mapService._mapView.on('drag', onDrag);

                executeCallbacks('mapview-create', null, mapService._mapView);
            }

            mapService.isInitialized = function () {
                return mapService.layers.length !== 0 || mapService._services.length !== 0;
            };

            mapService.reInitialize = function () {
                mapService.layers = [];
                map.layers.removeAll();

                for (var i = 0; i < mapService._factories.length; ++i) {
                    map.layers.add(mapService._factories[i].createLayer());
                }
            };

            mapService.addLayerFactory = function (factories) {
                for (var i = 0; i < factories.length; ++i) {
                    factories[i].ready().then(function (layerFactory) {
                        if (layerFactory.createLayerOnAdd) {
                            var layer = layerFactory.createLayer();

                            if (layer.onMouseMove) {
                                callbacks.mousemove.push(layer.onMouseMove);
                            }

                            if (layer.onRightClick) {
                                callbacks.rightclick.push(layer.onRightClick);
                            }

                            if (layer.onClick) {
                                callbacks.click.push(layer.onClick);
                            }

                            if (layer.onZoom) {
                                callbacks.zoom.push(layer.onZoom);
                            }

                            mapService._factories.push(layerFactory);
                            mapService.layers.push(layer);
                            if (layer.zIndex) {
                                map.add(layer, layer.zIndex);
                            } else {
                                map.add(layer);
                            }
                        }
                    });
                }
            };

            mapService.addLayerService = function (service) {
                service.ready().then(function (service) {
                    service.setup(mapService);

                    if (service.onMouseMove) {
                        callbacks.mousemove.push(service.onMouseMove);
                    }

                    mapService._services.push(service);
                });
            };

            mapService.on = function (eventName, callback) {
                if (callbacks[eventName]) {
                    callbacks[eventName].push(callback);
                }
            };

            mapService.zoomToPoint = function (point, zoomLevel, avoidZoomOut) {
                if (!mapService._is3D) {
                    const convertedCoords = mapUtility.convertToUTM33N(point.latitude, point.longitude);
                    point.X = convertedCoords.X;
                    point.Y = convertedCoords.Y;
                } else {
                    point.X = point.longitude;
                    point.Y = point.latitude;
                }
                const center = new Point(point.X, point.Y, new SpatialReference(mapService._is3D ? 4326 : 32633));
                mapService._mapView.center = center;

                if (zoomLevel) {
                    if (avoidZoomOut) {
                        if (mapService._mapView.zoom < zoomLevel) {
                            mapService._mapView.zoom = zoomLevel;
                        }
                    } else {
                        mapService._mapView.zoom = zoomLevel;
                    }
                }
            };

            mapService.rotate = function (angle) {
                mapService._mapView.rotation = angle;
            };

            mapService.showPopup = function (mapPoint, title) {
                mapService._mapView.popup.open({
                    title: title,
                    location: mapPoint,
                    collapsed: true
                });
            };

            mapService.hidePopup = function () {
                mapService._mapView.popup.close();
            };

            readyDeferred.resolve();
        });

        return mapService;
    }
})();
